import { ButtonBigComponent } from './button-big.component';

export default angular
  .module('sfMobile.components.button-big', [])
  .component('sfButtonBig', ButtonBigComponent).name;
